import { useRef } from "react";

import { ValidationResult, validationSuccessful } from "./ValidationResult";

export const useFormValidation = <TInput>(
    validate: (input: TInput, abortSignal: AbortSignal) => Promise<ValidationResult>
) => {
    const abortController = useRef<AbortController>(new AbortController());

    return (input: TInput): Promise<ValidationResult> => {
        abortController.current.abort();
        abortController.current = new AbortController();

        return new Promise((resolve, reject) => {
            validate(input, abortController.current.signal)
                .then((response) => {
                    if (response.isValid) {
                        resolve(validationSuccessful());
                    }

                    resolve(response);
                })
                .catch((error) => {
                    if (error?.name === "AbortError") {
                        resolve(validationSuccessful());
                    }

                    reject("Unexpected Error");
                });
        });
    };
};
